import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f3a01298&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f3a01298&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a01298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3a01298')) {
      api.createRecord('f3a01298', component.options)
    } else {
      api.reload('f3a01298', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f3a01298&scoped=true", function () {
      api.rerender('f3a01298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Boys/PayResult/index.vue"
export default component.exports